import type * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as contexts from '../../contexts'
import * as models from '../models'
import type { TypeParams } from '../types'

/**
 * Shows access flags only for Users tabs scoped to an admin entity context.
 */
export const syncAccessFlagsAttributeVisibility = store.effects.create(
  (
    feature: ec.Collection<TypeParams>['feature'],
    usersEc: ec.Collection<TypeParams>,
    contexts: contexts.Feature,
  ) => {
    const context$ = contexts.selectors.activeEntityContext.asObservable

    return rxjs
      .merge(
        context$,
        usersEc.plugins.attributePlugin.feature.actions.getAttributes.success
          .observe()
          .pipe(
            rxjs.withLatestFrom(context$),
            rxjs.map(([, context]) => context),
          ),
      )
      .pipe(
        rxjs.map(context => {
          const source = 'syncAccessFlagsAttributeVisibility (effect)'
          const action =
            context === undefined
              ? usersEc.plugins.attributePlugin.feature.actions.hideAttribute
              : usersEc.plugins.attributePlugin.feature.actions.showAttribute

          return action.from(source).create({
            attributeId: models.User.ACCESS_FLAGS_ATTRIBUTE_ID,
          })
        }),
      )
  },
)
